import type { StoryScript } from '../types';

/** Prototype — børnebog-stil; huller skrives frit under diktat. */
export const UGLE_I_TRAET: StoryScript = {
  id: 'ugle-i-traet',
  title: 'Ugle i træet',
  storyLevel: 1,
  defaultBlankLength: 12,
  blanks: {
    ting: {
      maxLength: 14,
      hint: 'fx ugle, hund eller kosteskab',
      definiteOnReuse: true,
    },
    navn: {
      maxLength: 10,
      hint: 'fx ida eller dit eget navn',
    },
  },
  beats: [
    { id: 'b1', template: 'i træet sad {{art:ting}} {{ting:14}}' },
    { id: 'b2', template: 'hej jeg hedder {{navn:10}} sagde {{ting}}' },
    { id: 'b3', template: '{{navn}} vinkede til mor' },
    { id: 'b4', template: 'så fløj {{ting}} op i træet' },
  ],
};
